import { host } from '@/constants/environment';
import { getSessionData } from '@/utils/session/sessionManager';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

interface CustomAxiosInstance extends AxiosInstance {
  get<T = unknown, R = T>(url: string, config?: AxiosRequestConfig): Promise<R>;
  post<T = unknown, R = T, D = unknown>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<R>;
  patch<T = unknown, R = T, D = unknown>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<R>;
  delete<T = unknown, R = T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<R>;
}

const axiosV2 = axios.create({
  baseURL: host,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}) as CustomAxiosInstance;

axiosV2.interceptors.request.use(
  (requestConfig) => {
    const session = getSessionData();
    if (session && session.apiV2Token) {
      requestConfig.headers.Authorization = `Bearer ${session.apiV2Token}`;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosV2;
